import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed } from "vue";
import { AttributeDisplayProps } from "@/types";
import { timestampToDisplay } from "@/util";
import { artifactStore } from "@/hooks";
import { Typography } from "../content";
import { AttributeChip } from "../chip";


/**
 * Displays a generic attribute.
 */
const __default__ = {
  name: "AttributeDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    values: {},
    attribute: {},
    showName: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dataCy = computed(() => `text-attribute-${props.attribute.key}`);
const isLink = computed(() =>
  String(props.values[props.attribute.key]).includes("://")
);

/**
 * The display values for an array attribute.
 */
const arrayValue = computed(() => {
  const value = props.values[props.attribute.key];
  const array = Array.isArray(value) ? value : [];

  return props.attribute.type === "relation"
    ? array.map((id) => artifactStore.getArtifactById(id)?.name || id)
    : array;
});

/**
 * The display values for all non-array attributes.
 */
const displayValue = computed(() => {
  const stringValue = String(props.values[props.attribute.key]);

  if (props.values[props.attribute.key] === undefined) {
    return "";
  } else if (props.attribute.type === "date") {
    return timestampToDisplay(stringValue).split(" at ")[0];
  } else if (props.attribute.type === "boolean") {
    return props.values[props.attribute.key] ? "Yes" : "No";
  } else {
    return stringValue;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { "data-cy": dataCy.value }, [
    (props.showName)
      ? (_openBlock(), _createBlock(_unref(Typography), {
          key: 0,
          variant: "caption",
          value: _ctx.attribute.label
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (isLink.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createVNode(_unref(Typography), {
            el: "a",
            value: displayValue.value
          }, null, 8, ["value"])
        ]))
      : (arrayValue.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayValue.value, (value) => {
              return (_openBlock(), _createBlock(_unref(AttributeChip), {
                key: value,
                value: value
              }, null, 8, ["value"]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 3,
            el: "p",
            value: displayValue.value
          }, null, 8, ["value"]))
  ], 8, _hoisted_1))
}
}

})